import { Controller } from "@hotwired/stimulus"
import { showNotification } from "./../helpers"

export default class extends Controller {
  static values = {
    accountPath: String,
    errorMessage: String,
    connectionErrorMessage: String
  }

  async enableAutoDownload(event) {
    const button = event.currentTarget
    button.disabled = true

    try {
      const response = await fetch(this.accountPathValue, {
        method: "PUT",
        headers: { "Content-Type": "application/json", "X-CSRF-Token": this.csrfToken },
        body: JSON.stringify({ account: { auto_download_expenses: true } })
      })

      if (response.ok) {
        window.location.reload()
      } else {
        this.handleError(button, this.errorMessageValue)
      }
    } catch {
      this.handleError(button, this.connectionErrorMessageValue)
    }
  }

  handleError(button, message) {
    button.disabled = false
    showNotification(message)
  }

  get csrfToken() {
    return document.querySelector("meta[name=\"csrf-token\"]")?.getAttribute("content") || ""
  }
}
